import { Route, Routes } from "react-router-dom"
import Authenticator from "./Pages/Authenticator/Authenticator"
import Home from "./Pages/Home/Home"
import "./App.css"
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SingleNotePage from "./Pages/Single Note page/SingleNotePage";
import DeleteNoteModel from "./Components/DeleteNoteModel";
import UpdateNoteModel from "./Components/UpdateNotes";
import Header from "./Components/Header/Header";
import { useGlobalContext } from "./Context/Authentation";
import AddNotesModel from "./Components/AddNotesModel";
import SearchPage from "./Pages/Search Page/SearchPage";


function App() {

  const { UpdateModalcontent, UpdateModalTitle, NoteId, DeleteModalTitle } = useGlobalContext();

  return (
    <>
      <div className="toast-container"><ToastContainer limit={2} /></div>
      <DeleteNoteModel title={DeleteModalTitle} NoteId={NoteId} />
      <UpdateNoteModel title={UpdateModalTitle} content={UpdateModalcontent} NoteId={NoteId} />
      <AddNotesModel />
      <div>
        <Routes>
          <Route path="/" element={<Authenticator />} />

          <Route path='Home' element={<Header />}>
            <Route path='allNotes' element={<Home />} />
            <Route path='Note/:id' element={<SingleNotePage />} />
            <Route path='Note/search' element={<SearchPage />} />
          </Route>

        </Routes>
      </div>
    </>
  );
}

export default App;
